import { Injectable } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { PromoCodesService } from '../../../+promo/services/promocodes.service';
import {
  IPromoCodeLog,
  IPromoCodesLogMetadata
} from '../../../+promo/interfaces/promo-code-log.interface';
import { IPromoCodeChainUserState } from '../../../+promo/interfaces/promo-code-chain-user-state.interface';

@Injectable()
export class PromoCodesHistoryDataSource extends DataSource<IPromoCodeLog> {
  logs$: BehaviorSubject<IPromoCodeLog[]> = new BehaviorSubject<
    IPromoCodeLog[]
  >([]);
  chainStates$: BehaviorSubject<
    IPromoCodeChainUserState[]
  > = new BehaviorSubject<IPromoCodeChainUserState[]>([]);
  supportsChainHistory$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  totalCount: number = 0;

  constructor(private promoCodesService: PromoCodesService) {
    super();
  }

  connect(): Observable<IPromoCodeLog[]> {
    return this.logs$.asObservable();
  }

  disconnect() {
    this.logs$.complete();
    this.chainStates$.complete();
    this.supportsChainHistory$.complete();
  }

  loadData(page: number, size: number, params: any): void {
    const offset: number = page * size;
    this.isLoading$.next(true);
    this.promoCodesService
      .getPromoCodesLog({ limit: size, offset }, params)
      .subscribe((res: IPromoCodesLogMetadata) => {
        this.logs$.next(res?.logs || []);
        this.chainStates$.next(res?.chainStates || []);
        this.supportsChainHistory$.next(
          Boolean(res && Object.prototype.hasOwnProperty.call(res, 'chainStates'))
        );
        this.totalCount = Number(res?.metadata?.amount || 0);
        this.isLoading$.next(false);
      });
  }
}
